<template>
  <b-modal
    id="supplierOrders-modal"
    ref="supplierOrders_modal"
    :title="modalTitle"
    @hidden="onClose"
    size="xl"
    :no-close-on-backdrop="isBusy"
  >
    <SupplierOrdersButtons v-if="selected == null" @on-open-form="setForm" />
    <SupplierOrderDoorForm ref="doorForm" v-if="selected == 'doors'" :constructionid="constructionid" />
    <template v-slot:modal-footer="{ cancel }">
      <b-button
        size="md"
        variant="primary"
        v-if="selected != null"
        @click="submit()"
        :disabled="isBusy"
      >
        Wyślij email z zamówieniem do dostawcy
      </b-button>
      <b-button
        size="md"
        variant="outline-danger"
        v-if="selected != null"
        @click="back()"
          :disabled="isBusy"
      >
        Anuluj
      </b-button>
      <b-button
        size="md"
        variant="outline-danger"
        v-if="selected == null"
        @click="cancel()"
      >
        Anuluj
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import SupplierOrdersButtons from "@/components/notes/SupplierOrdersButtons";
import SupplierOrderDoorForm from "@/components/notes/SupplierOrderDoorForm";
import ordersService from "@/services/supplierorders.service";

export default {
  name: "SupplierOrdersModal",
  components: {
    SupplierOrdersButtons,
    SupplierOrderDoorForm,
  },
  props: {
    constructionid: { type: Number },
  },
  data() {
    return {
      isBusy: false,
      selected: null,
    };
  },
  computed: {
    modalTitle() {
      switch (this.selected) {
        case "doors":
          return "Zamówienie na drzwi";

        default:
          return "Złóż zamówienie na:";
      }
    },
  },
  methods: {
    setForm(form) {
      this.selected = form;
    },
    submit() {
      if (this.selected == null) {
        return;
      }
      this.$Progress.start();
      this.isBusy = true;
      switch (this.selected) {
        case "doors":
          var data = this.$refs.doorForm.getData();

          if (data == null) {
            this.$Progress.stop();
            return;
          }
          ordersService.add(this.constructionid, data).then((newOrder) => {
            this.$emit("onSubmit", newOrder);
            this.$nextTick(() => {
              this.onClose();
            });
          }).finally(() => {
            this.isBusy= false;
          });
          break;
      }
    },
    onClose() {
      this.selected = null;
      this.$bvModal.hide("supplierOrders-modal");
      this.$emit("onClose");
    },
    back() {
      this.selected = null;
    },
    cancel() {
      this.onClose();
    },
  },
};
</script>
